import { jsx as _jsx } from "react/jsx-runtime";
import { DeclarativeModal } from 'seagull';
import { VendorOnboarding } from './VendorOnboarding';
export const VendorOnboardingOpener = (param)=>{
    let { isOpen, onComplete } = param;
    return /*#__PURE__*/ _jsx(DeclarativeModal, {
        isOpen: isOpen,
        treatAsPage: true,
        closeOnClickOutside: false,
        closeOnEscapeKey: false,
        biName: "vendor_onboarding_wizard",
        content: (param)=>{
            let { dismissModal } = param;
            return /*#__PURE__*/ _jsx(VendorOnboarding, {
                onComplete: ()=>{
                    dismissModal();
                }
            });
        },
        onClose: onComplete
    });
};
